import { useState } from 'react';
import './DeleteUserByEmail.css'; // We'll create this CSS file next
const SERVER_URL = process.env.REACT_APP_TEST_API_URL ;

const DeleteUserByEmail = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setMessage({ text: 'Please enter an email address', type: 'error' });
      return;
    }
    
    setIsLoading(true);
    setMessage({ text: '', type: '' });
    
    try {
      // Replace with your actual API endpoint
      const response = await fetch(SERVER_URL+'/api/auth/deleteUserbyEmail', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        const errorMessage = data.message || data.error || 'An unknown error occurred';
        throw new Error(errorMessage);
      }
      
      setMessage({ text: data.message || 'User successfully deleted', type: 'success' });
      setEmail('');
    } catch (error) {
      console.error('Error deleting user:', error);
      setMessage({ 
        text: error.message || 'Failed to delete user. Please try again.', 
        type: 'error' 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="delete-user-container">
      <div className="delete-user-card">
        <div className="delete-user-header">
          <h1>Delete User</h1>
          <p>Enter email address to remove user from system</p>
        </div>
        
        {message.text && (
          <div className={`message-box ${message.type}`}>
            <span className="message-icon">
              {message.type === 'success' ? '✓' : '✕'}
            </span>
            <span className="message-text">{message.text}</span>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="delete-user-form">
          <div className="form-group">
            <label htmlFor="email">User Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="user@example.com"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className={`delete-button ${isLoading ? 'loading' : ''}`}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : 'Delete User'}
          </button>
        </form>
      </div>
      
      <div className="warning-message">
        <span className="warning-icon">⚠️</span>
        <span>This action cannot be undone. Please be certain.</span>
      </div>
      
      <div className="back-link">
        <a href="/users">← Return to Users List</a>
      </div>
    </div>
  );
};

export default DeleteUserByEmail;